<template>
  <div class="d-flex fd-column h-100 ov-x-hidden">
    <pro-desk-reporting-header/>
    <div class="layout">
      <pro-desk-reporting-navigation class="layout-item bg-gray90 is-12 is-4:t is-3:d is-2:w"/>
      <div class="layout-item is-12 is-8:t is-9:d is-10:w ov-auto">
        <transition name="fade" mode="out-in">
          <router-view :key="$route.fullPath"/>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import ProDeskReportingHeader from './components/ProDeskReportingHeader';
import ProDeskReportingNavigation from './components/ProDeskReportingNavigation';

export default {
  name: 'pro-desk-reporting-layout',
  components: {
    ProDeskReportingNavigation,
    ProDeskReportingHeader,
  },
};
</script>
